module.exports = __webpack_public_path__ + "static/media/about-partner-carousel-3.e28b8865.png";